<template>
  <v-container style="height:100%;">
    <apexchart
      v-if="data[0] && data[0].data.length > 0"
      type="area"
      ref="lineChart"
      :options="options"
      :series="data"
      height="420"
    ></apexchart>
    <div
      v-else
      class="d-flex justify-center align-center"
      style="height: 420px;"
    >
      <v-progress-circular indeterminate size="64" />
    </div>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex';
import { MobileView } from '@/mixins';

export default {
  props: ['data', 'labels', 'subtitle', 'title', 'customOptions', 'yAxis'],
  mixins: [MobileView],
  computed: {
    ...mapGetters({
      _options: 'charts/getLineChart',
    }),
    options() {
      const options = { ...this._options };
      options.labels = this.labels;
      // options.title.text = this.title;
      if (this.customOptions && this.customOptions.colors) {
        options.colors = this.customOptions.colors;
      }
      if (this.yAxis) {
        options.yaxis = this.yAxis;
      }
      if (!this.showMobileView) {
        options.xaxis = {
          labels: {
            show: true,
            rotate: -45,
            rotateAlways: true,
            minHeight: 150,
          },
        };
      } else {
        options.xaxis = {
          labels: {
            show: true,
            rotate: -45,
            rotateAlways: true,
            minHeight: 170,
          },
        };
      }
      if (this.title === 'Device Utilization') {
        options.yaxis = {};
        options.yaxis.max = 100;
        options.tooltip = {
          custom({ series, seriesIndex, w, dataPointIndex }) {
            return (
              `${'<div style="background-color: white; padding: 5px;">' +
                '<span style="color: black; font-size: 10px;">' +
                `<span style="color: ${w.config.colors[seriesIndex]}; font-size: 16px; font-weight: bold;">`}${
                series[seriesIndex][dataPointIndex]
              }%` +
              '</span>' +
              '</div>'
            );
          },
        };
      }
      this.customOptions ? (options.colors = this.customOptions.colors) : '';
      this.customOptions ? (options.yaxis.max = this.customOptions.ymax) : '';
      this.customOptions ? (options.yaxis.min = this.customOptions.ymin) : '';
      if (!options.colors) {
        options.colors = [];
        options.colors[0] = this.$vuetify.theme.currentTheme.primary;
        options.colors[1] = this.$vuetify.theme.currentTheme.secondary;
      }
      return options;
    },
  },
  updated() {
    this.$emit('lineChartUpdated');
  },
  mounted() {
    this.$emit('lineChartUpdated');
  },
};
</script>
